// extracted by mini-css-extract-plugin
export var externalLink = "_f7-0";
export var internalLinkLabel = "_f7-1";